<template>
  <div>
    <workspace-users-list></workspace-users-list>
  </div>
</template>

<script>
import WorkspaceUsersList from '#/ui/Components/Workspace/WorkspaceUsersList.vue';

export default {
  components: { WorkspaceUsersList },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
